import { Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../app/hooks";
import { selectSubjectPerformedInsUpd, subjectPerformedInsUpdSlice } from "../../../../redux/curriculum/subjectPerformedInsUpdSlice";
import { selectSubjectList } from "../../../../redux/curriculum/subjectListSlice";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import { SubjectPerformedInfo } from "../../../../redux/curriculum/model";
import { useEffect } from "react";

export function SubjectPerformedInsUpdData() {
    const insUpd = useSelector(selectSubjectPerformedInsUpd);
    const subjects = useSelector(selectSubjectList);
    const dispatch = useAppDispatch();

    const setValue = (key: keyof SubjectPerformedInfo, value: string | number | undefined) => {
        dispatch(subjectPerformedInsUpdSlice.actions.set({
            ...insUpd.subjectPerformed, 
            [key]: value 
        }));
    };

    console.log("SubjectPerformedInsUpdData render", insUpd.subjectPerformed);

    useEffect(() => {
        const value = { ...insUpd.subjectPerformed } as SubjectPerformedInfo;
        if (!value.startedAt) {
            value.startedAt = dayjs().set('hour', 8).set('minute', 0).set('second', 0).toISOString();
        }
        if (!value.endedAt) {
            value.endedAt = dayjs().set('hour', 9).set('minute', 0).set('second', 0).toISOString();
        }
        dispatch(subjectPerformedInsUpdSlice.actions.set(value));
    }, []);

    useEffect(() => {
        if (insUpd.subjectPerformed.startedAt && insUpd.subjectPerformed.endedAt) {
            const startedAt = dayjs(insUpd.subjectPerformed.startedAt);
            const endedAt = dayjs(insUpd.subjectPerformed.endedAt);
            const hours = Math.ceil(endedAt.diff(startedAt, "minute") / 60);
            setValue("hoursPerformed", hours);
        }
    }, [insUpd.subjectPerformed.startedAt, insUpd.subjectPerformed.endedAt]);

    return <>
        <Typography variant="h6" gutterBottom>
            Dados da Aula
        </Typography>
        <Grid container spacing={3}>
            <Grid size={12}>
                <TextField
                    required
                    id="subjectId"
                    label="Disciplina"
                    select
                    fullWidth
                    variant="standard"
                    error={insUpd.subjectPerformed.subjectId <= 0}
                    value={insUpd.subjectPerformed.subjectId > 0 ? insUpd.subjectPerformed.subjectId : ""}
                    onChange={(e) => setValue("subjectId", Number(e.target.value))}
                >
                    {(subjects.list || []).map((item) => (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid size={6}>
                <DateTimePicker
                    value={insUpd.subjectPerformed.startedAt ? dayjs(insUpd.subjectPerformed.startedAt) : null  }
                    onChange={(newValue) => {
                        if (newValue) setValue("startedAt", newValue.toISOString());
                    }}
                    disabled={false}
                    label="Data e hora de inicio"
                    format="DD/MMM/YYYY HH:mm"
                    ampm={false}
                    slotProps={{ textField: { size: "small" } }}
                />
            </Grid>
            <Grid size={6}>
                <DateTimePicker
                    value={insUpd.subjectPerformed.endedAt ? dayjs(insUpd.subjectPerformed.endedAt) : null}
                    onChange={(newValue) => {
                        if (newValue) setValue("endedAt", newValue.toISOString());
                    }}
                    disabled={false}
                    label="Data e hora de término"
                    format="DD/MMM/YYYY HH:mm"
                    ampm={false}
                    slotProps={{ textField: { size: "small" } }}
                />

            </Grid>
            <Grid size={6}>
                <TextField
                    id="hoursPerformed"
                    label="Horas Realizadas"
                    type="number"
                    fullWidth
                    variant="standard"
                    inputProps={{ min: 0, step: 0.5 }}
                    value={insUpd.subjectPerformed.hoursPerformed ?? ""}
                    onChange={(e) => setValue("hoursPerformed", e.target.value !== "" ? Number(e.target.value) : undefined)}
                />
            </Grid>
        </Grid>
    </>;
}
